var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file","name":"file","id":"file"}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.initUpload(0)}}},[_vm._v("upload")]),_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.mergeSlice}},[_vm._v("合并")]),_c('div',[_c('el-progress',{attrs:{"percentage":_vm.percent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }